import { Component, OnInit } from '@angular/core';

import { PrimeNGConfig } from 'primeng-lts/api';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(
    private primengConfig: PrimeNGConfig
  ) {
  }

  ngOnInit(): void {
    setInterval(() => this.silentRefreshKeycloakSession(), 240000);
    this.primengConfig.ripple = true;
  }
  silentRefreshKeycloakSession() {
    const realm = 'apps_iam';
    const clientId = 'ttc-invoice';
    const redirectUri = window.location.origin + '/silent-refresh-callback.html';

    const keycloakBase = environment.keycloakBase;

    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${keycloakBase}/realms/${realm}/protocol/openid-connect/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=openid&prompt=none`;
    document.body.appendChild(iframe);
    setTimeout(() => document.body.removeChild(iframe), 5000);
  }


}
